import rtlStyle from '../src/styles/rtl.cssr'

export default {
  name: 'PageHeader',
  style: rtlStyle
}
